function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_41547_42199)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.8655 4.58213C20.5796 3.5152 19.4829 2.88203 18.416 3.16792L2.96115 7.30902C1.89422 7.59491 1.26105 8.69158 1.54693 9.75851L2.06457 11.6904C3.66497 11.2615 5.30998 12.2113 5.73881 13.8117C6.16763 15.4121 5.21789 17.0571 3.61749 17.4859L4.13513 19.4178C4.42101 20.4847 5.51768 21.1179 6.58462 20.832L22.0394 16.6909C23.1064 16.405 23.7395 15.3083 23.4536 14.2414L22.936 12.3095C21.3356 12.7384 19.6906 11.7886 19.2618 10.1882C18.8329 8.58782 19.7827 6.94281 21.3831 6.51398L20.8655 4.58213Z",
  fill: "#4E8DD7",
  stroke: "#4E8DD7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.60156 10.9739L15.363 9.16214",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.63672 14.8376L16.3982 13.0259",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_41547_42199"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(0.5)"
})));

var SvgTicketIcon = function SvgTicketIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTicketIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ticket-icon.0e52dd6a.svg";
export { ForwardRef as ReactComponent };